import {
  ACCEPT_INVITE_REQUEST,
  ALL_USERS_REQUEST,
  FEEDBACK_REQUEST,
  INVITE_REQUEST,
  INVITES_LIST_REQUEST,
  RESEND_INVITE_REQUEST,
  RESET_BLOCK_MANAGER,
  USER_DETAILS_REQUEST,
  VALIDATE_REQUEST,
} from '../reducers/ManagerReducer';

export const getInvites = () => ({ type: INVITES_LIST_REQUEST });

export const sendInvite = (payload) => ({ type: INVITE_REQUEST, payload });

export const resendInvite = (payload) => ({
  type: RESEND_INVITE_REQUEST,
  payload,
});

export const validateInvite = (payload) => ({
  type: VALIDATE_REQUEST,
  payload,
});

export const acceptInvite = (payload) => ({
  type: ACCEPT_INVITE_REQUEST,
  payload,
});

export const sendFeedback = (payload) => ({
  type: FEEDBACK_REQUEST,
  payload,
});

export const reset = (block) => ({ type: RESET_BLOCK_MANAGER, block });

export const getAllUsers = () => ({
  type: ALL_USERS_REQUEST,
});

export const getUserDetails = (payload) => ({
  type: USER_DETAILS_REQUEST,
  payload,
});
